// extracted by mini-css-extract-plugin
export default {"item-rating":"Rating_item-rating__hvNdH","filledStar":"Rating_filledStar__FoJAd","outlineStar":"Rating_outlineStar__TsxsA"};